@if (value() === true) {
  <span class="visually-hidden" i18n>yes</span>
  <my-global-icon iconName="tick"></my-global-icon>
} @else {
  <span class="visually-hidden" i18n>no</span>
  <my-global-icon iconName="cross"></my-global-icon>
}
